import React from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { SocialAccountCard } from "./SocialAccountCard";
import { PrimaryActionButton } from "@/components/ui/PrimaryActionButton";
import { DataStatusDot } from "./DataStatusDot";
import { useTranslation } from "react-i18next";

interface FacebookAccountCardProps {
  profile: {
    id: string;
    name: string;
    email?: string;
    picture_url?: string;
    connected_at: string;
    connectionId: string;
  };
  isLoading?: boolean;
  onDisconnect: (connectionId?: string) => void;
  onFetchInstagramAccounts: () => Promise<void>;
  isFetchingInstagramAccounts?: boolean;
}

export function FacebookAccountCard({
  profile,
  isLoading = false,
  onDisconnect,
  onFetchInstagramAccounts,
  isFetchingInstagramAccounts = false
}: FacebookAccountCardProps) {
  const { t } = useTranslation();
  const handleDisconnect = () => {
    onDisconnect(profile.connectionId);
  };

  const actions = (
    <PrimaryActionButton
      className="w-full"
      onClick={onFetchInstagramAccounts}
      disabled={isFetchingInstagramAccounts || isLoading}
      isLoading={isFetchingInstagramAccounts}
      loadingText={t("account.facebook_fetching_instagram_accounts", "Fetching Instagram Accounts...")}
      icon={<FaInstagram />}
    >
      {t("account.facebook_select_instagram_accounts", "Select Instagram Accounts")}
    </PrimaryActionButton>
  );

  return (
    <SocialAccountCard
      title={profile.name}
      username={profile.email}
      subtitle={t(
        "account.facebook_connected_instagram_subtitle",
        "Facebook account connected. Select Instagram accounts connected to your Facebook account below."
      )}
      profilePictureUrl={profile.picture_url}
      icon={<FaFacebook />}
      isLoading={isLoading}
      onDisconnect={handleDisconnect}
      statusDot={<DataStatusDot connectionIds={[profile.connectionId]} />}
      actions={actions}
    />
  );
}